import type { BillingBlockedBody } from "@/types/billing";

export class BillingBlockedError extends Error {
  readonly body: BillingBlockedBody;

  constructor(body: BillingBlockedBody) {
    super(`Billing blocked: ${body.reason}`);
    this.name = "BillingBlockedError";
    this.body = body;
  }
}

export function isBillingBlockedError(err: unknown): err is BillingBlockedError {
  return err instanceof BillingBlockedError;
}
